import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";

import { PageWrapper } from "../../../components/PageWrapper";
import { ClipboardScoreNeverNoShowContent } from "./Content";
import { ClipboardScoreNeverNoShowHeader } from "./Header";

export function ClipboardScoreNeverNoShow() {
  return (
    <PageWrapper variant="tertiary">
      <PageHeaderWrapper variant="tertiary">
        <ClipboardScoreNeverNoShowHeader />
      </PageHeaderWrapper>
      <PageContent sx={{ paddingX: 7 }}>
        <ClipboardScoreNeverNoShowContent />
      </PageContent>
    </PageWrapper>
  );
}
